import { Pipe, PipeTransform } from "@angular/core";
import { HealthRecord } from "src/app/backend/models/health-record";
import { sntTranslate } from "src/app/support/translate";
import { marker } from "@jsverse/transloco-keys-manager/marker";

@Pipe({
  name: "openHealthRecordTitle",
  standalone: false
})
export class OpenHealthRecordTitlePipe implements PipeTransform {
  transform(healthRecord: HealthRecord, html: boolean = false): string {
    return html
      ? `${sntTranslate(marker("Apri"))} <span class="italic font-medium">${
          healthRecord.name
        } ${healthRecord.number}</span>`
      : `${sntTranslate(marker("Apri"))} ${healthRecord.name} ${
          healthRecord.number
        }`;
  }
}
